export default {
  list: {
    headers: {
      id: "ID",
      name: "Nazwa ścieżki",
      nameAtHome: "Nazwa ścieżki na /home",
      activeTo: "Aktywna do",
      series: "Przypisane serie",
      company: "Firma",
      language: "Wersja",
      b2c: "B2C",
      type: "Typ",
      pathType: "Rodzaj ścieżki",
    },
    pathTypes: {
      standard: "Standard",
      rpg: "RPG",
    },
    filters: {
      series: "Przypisane serie",
      company: "Firma",
      activeTo: "Data zakończenia",
      from: "od",
      to: "do",
      b2c: "B2C",
    },
  },
  form: {
    name: "Nazwa ścieżki",
    nameAtHome: "Nazwa ścieżki na /home",
    description: "Opis ścieżki",
    slug: "Slug",
    slugDescription:
      "Ustal unikalny ciąg znaków, który znajdziemy zazwyczaj po ukośniku w adresie URL podstrony.",
    slogan: "Hasło ścieżki",
    addToCompany: "Dodaj do firmy",
    optional: "opcjonalnie",
    noCompany: "Brak firmy",
    active: "Aktywna",
    changeRequest: "Wymuś zmianę",
    language: "Wybierz język",
    tags: "Tagi",
    enterToSave: "Naciśnij Enter, aby zapisać tag",
    dateFrom: "Ścieżka ważna od",
    dateTo: "Ścieżka ważna do",
    b2c: "Ścieżka dla B2C",
    certificate: "Certyfikat",
    certificateFile: "grafikę certyfikatu",
    certificateDescription: "Opis certyfikatu",
    series: "Serie",
    seriesDescription: "Najpierw wybierz język żeby wybrać serie",
    seriesAiSchool: "Szukaj w serii Szkoły AI",
    aiSchoolTag: "Szkoła AI",
    companySeriesRemoved: "Usunięto szkolenia innej firmy — szkolenie firmowe może być tylko w ścieżce swojej firmy.",
    tagExists: "Taki tag został już dodany",
    addPath: "Dodaj ścieżkę",
    isNew: "Nowość",
  },
  searchPath: "Wyszukaj ścieżkę",
  normal: "Zwykła",
};
